export const BUTTON_TYPE = {
  LATER: 'later',
  VIEW: 'view',
  NONE: 'none'
};
